import axios from '../../http/axios/index.js'

export default {
  getAdditionalData ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
      //TODO: Cambiar la url por la correcta
        .post('/getAdditionalData',
          {
            id_request_type: item.id_request_type,
            id_request: item.id_request,
          },
          {
            headers: {
              //Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          // console.log("Respuesta de datos adicionales: " + JSON.stringify(response))
          if (response.status === 200) {
            try{

              console.log('Datos adicionales length', response.data.requestTypeByAddData.length)

              const lista = response.data.requestTypeByAddData ? response.data.requestTypeByAddData : []
              commit('SET_ADDITIONAL_DATA', lista)
              resolve(response)
            }catch(e){
              console.log(e)
            }
          } else {
            reject(response)
          }
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  setAdditionalData ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
      //TODO: Cambiar la url por la correcta
        .post('/setAdditionalData',
          item,
          {
            headers: {
              //Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          // console.log("Respuesta de datos adicionales: " + JSON.stringify(response))
          if (response.status === 200) {
            try{


            }catch(e){
              console.log(e)
            }
          } else {
            reject(response)
          }
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  setAddDataListState ({ commit }, item) {
    commit('SET_ADDITIONAL_DATA', item)
  }
}
